export default __webpack_public_path__ + "static/img/vogue_scene_animated_0812.00b1b37.webp";